import { Injectable } from '@angular/core';

import { TaskMapper } from '../contracts/task-mapper.contract';
import { TaskDataMap, TaskResponse, TaskType } from '../models/task.interface';

@Injectable()
export class ServiceRequestTaskMapper implements TaskMapper<TaskType.ServiceRequest> {
  readonly type = TaskType.ServiceRequest;

  map(r: TaskResponse): TaskDataMap[TaskType.ServiceRequest] {
    return {
      serviceCategory: r.data?.['serviceCategory'] ?? '',
      notes: r.data?.['notes'] ?? '',
      memberId: r.data?.['memberId'] ?? '',
      memberName: r.data?.['memberName'] ?? '',
    };
  }
}
